var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 47.6 46.6",
    style: {
      enableBackground: "new 0 0 47.6 46.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#E5E8EC;}\n\t.st3{fill:#C5E1F9;}\n\t.st4{fill:none;stroke:#0561FC;stroke-width:5;stroke-miterlimit:10;}\n\t.st5{fill:#0561FC;}\n\t.st6{fill:none;stroke:#FFFFFF;stroke-width:3.4127;stroke-miterlimit:10;}\n\t.st7{fill:#7EB3FF;}\n\t.st8{fill:none;stroke:#EAF4FE;stroke-width:2;}\n\t.st9{fill:#B2D2EA;}\n\t.st10{fill:#EAF4FE;}\n\t.st11{fill:#FFC400;}\n\t.st12{fill:none;stroke:#0561FC;stroke-width:2;}\n\t.st13{fill:none;stroke:#9AC7F7;stroke-width:2;}\n\t.st14{fill:#0450CF;}\n\t.st15{fill:none;stroke:#C5E1F9;stroke-width:2;}\n\t.st16{fill:none;stroke:#282D33;stroke-width:2;}\n\t.st17{fill:#0561FC;stroke:#0561FC;stroke-width:2;}\n\t.st18{fill:#7EB3FF;stroke:#7EB3FF;stroke-width:2;}\n\t.st19{fill:none;stroke:#7EB3FF;stroke-width:2;}\n\t.st20{fill:#FD2227;}\n\t.st21{fill:#FFAB01;}\n\t.st22{fill:none;stroke:#FFFFFF;stroke-width:2;}\n\t.st23{fill:none;stroke:#0561FC;stroke-width:3.1399;}\n\t.st24{fill:#FFBF0D;}\n\t.st25{fill:#9AC7F7;}\n\t.st26{fill:#34A853;}\n\t.st27{fill:none;stroke:#0561FC;stroke-width:3.2246;stroke-miterlimit:10;}\n\t.st28{fill:none;stroke:#0561FC;stroke-width:4.8196;}\n\t.st29{fill:#EAF4FE;stroke:#0561FC;stroke-width:2;}\n\t.st30{fill:none;stroke:#0561FC;stroke-width:2;stroke-miterlimit:10;}\n\t.st31{fill:none;stroke:#EAF4FE;stroke-width:2;stroke-miterlimit:10;}\n\t.st32{fill:none;stroke:#7EB3FF;stroke-width:3.4127;stroke-miterlimit:10;}\n\t.st33{fill:none;stroke:#B2D2EA;stroke-width:2;}\n\t.st34{fill:none;stroke:#0561FC;stroke-width:2.6163;}\n\t.st35{fill:#0561FC;stroke:#0561FC;stroke-width:2;stroke-miterlimit:10;}\n\t.st36{fill:none;stroke:#0561FC;stroke-width:5.5196;}\n\t.st37{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Square",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.1,
    y: -2,
    className: "st2",
    width: 48,
    height: 48
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    className: "st1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st32",
    points: "12.1,17.3 16.6,21.8 26.4,12.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 18,
    cy: 18,
    r: 17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.1,
    y: 30.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -15.4766 38.7785)",
    className: "st17",
    width: 4,
    height: 16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 33,
    y1: 32,
    x2: 30.5,
    y2: 29.5
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M5.9,18c0-6.7,5.4-12.1,12.1-12.1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1a69a8365c1a4dd5ccdf5eed8e34dfd1.svg";
export { ForwardRef as ReactComponent };